/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import commonUtil from '../../../../../utils/commonUtil';
import AccountStatusWAP from './AccountStatusWAP';
import AccountStatus from './AccountStatus';
import ApplyCSS from '../../../../../components/ApplyCSS';
import Transition from '../../../../../components/Transition';
import * as accountStatusDetailsAction from '../../actions';
import { getEventSummaryInfo } from '../../../../eventManagement/page/GiftList/actions';
import * as labelsActions from '../../../../../components/labels/actions';
import * as getGlobleObject from '../../../../../components/globleObject/reducer';
import Tagging from '../../../../../components/Tagging/Tagging';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

const { getEventAccountStatementDetails, getInTransitDetails, getStatementDetailsForPrintAndDownload } = accountStatusDetailsAction;

const { isLablesLoaded, loadLables } = labelsActions;

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},

])
@connect(store => ({
  content: store.targetterContent.data,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  { labelsActions })

class AccountStatusIndex extends Component {
  constructor(props) {
    super(props);
    this.getStatementDetailsForPrintAndDownloadData = null;
    this.state = {
      statementPrintAndDownload: null,
    };
  }
  componentDidMount() {
    commonUtil.addTransition();

    let url = this.props.route.path.split('(');
    url = url[0];

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: url,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Estado de Cuenta',
      Site: 'Mesa de Regalos',
      idMesa: this.eventId,
    });

    // eslint-disable-next-line no-undef
  }
  UNSAFE_componentWillMount() {
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    this.props.getEventAccountStatementDetails(this.eventId);
    this.props.getInTransitDetails(this.eventId);
    this.props.getStatementDetailsForPrintAndDownload(this.eventId);
    if (!_.isEmpty(this.props.state.user.data) && !_.isEmpty(this.props.state.user.data.result)) {
      this.props.getEventSummaryInfo(this.eventId, this.props.state.user.data.result.profileId, this.props.state.user.data.result.emailId);
    }
  }

  getEventAccountStatementDetailsFunction = () => {
    this.props.getEventAccountStatementDetails(this.eventId);
    this.props.getEventSummaryInfo(this.eventId, this.props.state.user.data.result.profileId, this.props.state.user.data.result.emailId);
  }

  render() {
    return (
      <div>
        <Tagging ref={tagging => this.tagging = tagging} />
        <ApplyCSS pageName="accountstatus" />
        <Transition eventId={this.eventId} />
        {!_.isEmpty(this.props.lables) &&
          !_.isEmpty(this.props.accountStatus) && !_.isEmpty(this.props.accountStatus.eventAccountStatementInfo) &&
          !_.isEmpty(this.props.intransitData) &&
          !_.isEmpty(this.props.eventInfo)
          ? <div>
            {channel === constChannels.WEB ? <AccountStatus
              ref={accountStatus => this.accountStatus = accountStatus}
              lables={this.props.lables}
              accountStatus={this.props.accountStatus}
              intransitData={this.props.intransitData}
              emaildata={this.props.emaildata}
              eventInfo={this.props.eventInfo}
              eventId={this.eventId}
              user={this.props.user}
              getEventAccountStatementDetails={this.getEventAccountStatementDetailsFunction}
              statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
              printingDate={this.props.printingDate}
            />
              : <AccountStatusWAP
                ref={accountStatusWAP => this.accountStatusWAP = accountStatusWAP}
                lables={this.props.lables}
                accountStatus={this.props.accountStatus}
                intransitData={this.props.intransitData}
                emaildata={this.props.emaildata}
                eventInfo={this.props.eventInfo}
                eventId={this.eventId}
                user={this.props.user}
                getEventAccountStatementDetails={this.getEventAccountStatementDetailsFunction}
                statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                printingDate={this.props.printingDate}
              />
            }
          </div>
          : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  state,
  user: state.user && state.user.data,
  lables: state.labels,
  accountStatus: state.accountSummary && state.accountSummary.accountStatus,
  intransitData: state.accountSummary && state.accountSummary.intransit,
  eventInfo: state.accountSummary && state.accountSummary.eventInfo && state.accountSummary.eventInfo.eventInfo,
  statementDetailsForPrintAndDownloadData: state.accountSummary && state.accountSummary.statementDetailsForPrintAndDownloadData,
  printingDate: state.info && state.info.data && state.info.date.time,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getGlobleObject, getEventAccountStatementDetails, getInTransitDetails, getEventSummaryInfo, getStatementDetailsForPrintAndDownload }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(AccountStatusIndex);
